module.exports = __webpack_public_path__ + "static/img/topTit.ed1e0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/topTit.png
// module id = TqGI
// module chunks = 0